import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { logService } from '../api/log.service';

export const VersionDialog = ({
  open,
  onClose,
  versionId
}: {
  open: boolean;
  onClose: () => void;
  versionId: number;
}) => {
  const translationPrefix = 'pages.versions.detail';
  const [fields, setFields] = useState<any>([]);

  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;

    logService.get(`/${versionId}/`).then((res) => {
      let newFields: any[] = [];
      let changes = {};
      if (res.changes) {
        if (typeof res.changes === 'string') {
          try {
            changes = JSON.parse(res.changes);
          } catch (e) {
            console.error('Errore nel parsing di res.changes:', e);
            changes = {};
          }
        } else {
          changes = res.changes;
        }
      }
      if (res.full_object) {
        newFields = Object.entries(res.full_object).map(([field, value], id) => {
          const fieldChange = changes[field];
          let newValue = value;
          let oldValue = value;
          if (fieldChange) {
            newValue = fieldChange[1];
            oldValue = fieldChange[0];
          }

          if (typeof oldValue === 'boolean') {
            oldValue = oldValue ? t('global.yes') : t('global.no');
          }
          if (typeof newValue === 'boolean') {
            newValue = newValue ? t('global.yes') : t('global.no');
          }

          const displayOldValue =
            typeof oldValue === 'object' && oldValue !== null ? JSON.stringify(oldValue) : oldValue;
          const displayNewValue =
            typeof newValue === 'object' && newValue !== null ? JSON.stringify(newValue) : newValue;

          field = t(`pages.versions.entities.${res.model_name}.${field}` as any);

          return {
            id,
            field,
            oldValue: displayOldValue,
            newValue: displayNewValue,
            edited: !!fieldChange
          };
        });
      }
      setFields(newFields);
    });
  }, [open, versionId, t]);

  const columns: GridColDef[] = useVersionColumns();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle>{t(`${translationPrefix}.title`) + ` ${versionId}`}</DialogTitle>
      <DialogContent sx={{ height: '70vh', minHeight: 360 }}>
        <DataGridPremium
          rows={fields}
          columns={columns}
          disableRowSelectionOnClick
          disableColumnMenu
          getRowHeight={() => 'auto'}
          getEstimatedRowHeight={() => 56}
          getRowClassName={(params) => (params.row.edited ? 'mui-edited' : '')}
          sx={{
            height: '100%',
            '& .MuiDataGrid-cell': {
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.35,
              py: 1
            },
            '& .mui-edited': {
              backgroundColor: '#fff8e1'
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('actions.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionDialog;
function useVersionColumns(): GridColDef[] {
  throw new Error('Function not implemented.');
}
